import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, debounce } from '@mui/material';
import { getReservationList } from 'redux/actions/reservationAction';
import CommonSubHeader from 'components/commonSubHeader/CommonSubHeader';
import CommonTable from 'components/commonTable/CommonTable';
import Loader from 'components/loader/Loader';
import useModal from 'hooks/useModal';
import DispatchModal from './DispatchModal';
import AllotVehicleModal from '../allRides/AllotVehicleModal';
import CancelRegistrationModal from '../cancelRegistrationModal/CancelRegistrationModal';
import { getDateFormat, handlePermissions } from 'utils/utils';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';

const Allot = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const startDate = searchParams?.get('startDate');
  const endDate = searchParams?.get('endDate');
  const filterPage = searchParams?.get('page');
  const filterRowPerPage = searchParams?.get('rowPerPage');
  const filterSearch = searchParams?.get('search');
  const reservationList = useSelector(
    (state) => state.getReservationList?.reservationList?.data
  );
  const reservationListLoader = useSelector(
    (state) => state.getReservationList?.loading
  );

  // ----FormatingDate---
  const handleDateFormating = (data) => {
    return getDateFormat(data, "reservationDateFormat");
  };

  const { open: dispatchMoal, toggle: setDispatchModal } = useModal();
  const { open: allotModal, toggle: setAllotModal } = useModal();
  const { open: cancelModal, toggle: setCancelModal } = useModal();

  const [page, setPage] = useState(filterPage ? parseInt(filterPage) : 0);
  const [rowsPerPage, setRowsPerPage] = useState(filterRowPerPage ? filterRowPerPage : 10);
  const [details, setDetails] = useState({});
  const [search, setSearch] = useState(filterSearch ? filterSearch : '');
  const [dateFrom, setDateFrom] = useState((startDate && startDate !== 'null') ? startDate : startDate === 'null' ? '' : handleDateFormating(new Date()));
  const [dateTo, setDateTo] = useState((endDate && endDate !== 'null') ? endDate : endDate === 'null' ? '' : handleDateFormating(new Date()));
  
  let paramsList = {};
  searchParams.forEach((value, key) => {
    paramsList[key] = value;
  });

  let filterData = {
    B2B: true,
    page: page,
    dateFrom: dateFrom ? dateFrom : '',
    dateTo: dateTo ? dateTo : '',
    status: 'alloted',
    pageSize: rowsPerPage ? rowsPerPage : '',
    search: search ? search : '',
  };

  useEffect(() => {
    dispatch(getReservationList(filterData));
  }, []);

  const tableOnClickRow = (navigate, val) => {
    navigate(`/operation/allot/bookingdetails?id=${val.id}&startDate=${dateFrom}&endDate=${dateTo}&type=allot&page=${page}&rowPerPage=${rowsPerPage}&search=${search}`);
    };

  const onSearchQuery = debounce((e) => {
    setSearchParams({...paramsList, page:0, search:e})
    setPage(0);
    setSearch(e);
    const searchFilterData = {
      ...filterData,
      search: e,
      page: 0,
      pageSize: '',
      status: 'alloted',
    };
    dispatch(getReservationList(searchFilterData));
  }, 1000);

  const onSelectDateRange = (newValue) => {
    if (newValue === null || !newValue) {
      setSearchParams({...paramsList, startDate: 'null', endDate: 'null'})
      setDateFrom('');
      setDateTo('');
      filterData = { ...filterData, dateFrom: '', dateTo: '' };
    } else {
      setSearchParams({...paramsList, startDate:handleDateFormating(newValue[0]), endDate:handleDateFormating(newValue[1])})
      setDateFrom(handleDateFormating(newValue[0]));
      setDateTo(handleDateFormating(newValue[1]));
      filterData = {
        ...filterData,
        dateFrom: handleDateFormating(newValue[0]),
        dateTo: handleDateFormating(newValue[1]),
      };
    }
    dispatch(getReservationList(filterData));
  };

  const handleChangePage = (event, newPage) => {
    setSearchParams({...paramsList, page:newPage})
    setPage(newPage);
    dispatch(
      getReservationList({ ...filterData, page: newPage, status: 'alloted' })
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setSearchParams({...paramsList, rowPerPage:parseInt(event.target.value), page:0})
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getReservationList({
        ...filterData,
        page: 0,
        pageSize: parseInt(event.target.value),
        status: 'alloted',
      })
    );
  };

  const handleOperation = (event, status, ele) => {
    event.preventDefault();
    event.stopPropagation();
    if (status === 'Alloted') {
      setDispatchModal();
      setDetails(ele);
    }
  };

  const onClickMoreIcon = (tripData, ele) => {
    if (ele === 'Re-Allot') {
      setDetails(tripData);
      setAllotModal();
    } else if (ele === 'Cancel Duty') {
      setDetails(tripData);
      setCancelModal();
    }
  };

  const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
  const allotRoles = roleAndPermissionEnum.operation
  const accessForCancel = handlePermissions(roleAndPermissions, allotRoles.moduleKey, {customAccess: allotRoles.allotTrip.allotTripCancel});
  const accessForReallot = handlePermissions(roleAndPermissions, allotRoles.moduleKey, {customAccess: allotRoles.allotTrip.allotTripReallot});
  const accessForDispatch = handlePermissions(roleAndPermissions, allotRoles.moduleKey, {customAccess: allotRoles.allotTrip.allotTripDispatch});

  const hasViewMoreIcon =(accessForCancel || accessForReallot)
  const accessForAllotAndCancel = (accessForCancel && accessForReallot)

  return (
    <Box className="allotContainer">
      <Box className="mb20">
        <CommonSubHeader
          filter={false}
          onSelectDateRange={onSelectDateRange}
          onSearchQuery={onSearchQuery}
          dateFrom={dateFrom}
          dateTo={dateTo}
          search={search}
        />
      </Box>
      {reservationListLoader ? (
        <Loader />
      ) : (
        <CommonTable
          data={reservationList}
          accessForReallot={accessForReallot}
          accessForOperations={accessForDispatch}
          tabName="operation"
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleOperation={handleOperation}
          tableOnClickRow={tableOnClickRow}
          onClickMoreIcon={onClickMoreIcon}
          accessForCancel={accessForCancel}
          page={page}
          rowsPerPage={rowsPerPage}
          isClickable={true}
          viewMoreIcon={!hasViewMoreIcon}
          accessForAllotAndCancel={accessForAllotAndCancel}
        />
      )}
      <AllotVehicleModal
        open={allotModal}
        toggle={setAllotModal}
        tripDetails={details}
        page={'allot'}
        payload={filterData}
      />
      <DispatchModal
        page={'allot'}
        open={dispatchMoal}
        toggle={setDispatchModal}
        tripDetails={details}
        payload={filterData}
      />
      {cancelModal && <CancelRegistrationModal
        page={'allot'}
        open={cancelModal}
        toggle={setCancelModal}
        reservationData={details}
        payload={filterData}
      />}
    </Box>
  );
};

export default Allot;
